// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__2HXSz","total-price":"Cart_total-price__P0prb","actions":"Cart_actions__l1l2y","cancel":"Cart_cancel__SP3+T"};